import { instance } from './ApiRequest';
import {
    INTERVIEW_SCHEDULE_VALIDATE_IMPORT, INTERVIEW_SCHEDULE_CONFIRM_IMPORT, INTERVIEW_SCHEDULE_SEARCH,
    INTERVIEW_SCHEDULE_GET_BY_ID, INTERVIEW_SCHEDULE_RELEASE, INTERVIEW_SCHEDULE_UNRELEASE,
    INTERVIEW_SCHEDULE_ARCHIVE, INTERVIEW_SCHEDULE_UPDATE, INTERVIEW_SCHEDULE_GET_FOR_CANDIDATE,
    INTERVIEW_SCHEDULE_VALIDATE_CALL_LETTER_RELEASE, INTERVIEW_SCHEDULE_PREVIEW_CALL_LETTER,
    INTERVIEW_SCHEDULE_RELEASE_CALL_LETTERS, INTERVIEW_SCHEDULE_UNRELEASE_CALL_LETTERS,
    INTERVIEW_SCHEDULE_GET_CALL_LETTER_FOR_CANDIDATE, INTERVIEW_SCHEDULE_RECORD_CALL_LETTER_DOWNLOAD
} from 'constants/constants';

// Phase B (Interview Scheduling) — a dedicated module for the new backend surface, following the same
// "one small module per related API surface" convention AnswerKeyService.js/PublicationService.js
// already established.
let _InterviewScheduleService = {
    // Admin-facing, Global-Admin-gated on the backend.
    async validateImport(postId, file) {
        const body = new FormData();
        body.append('files[]', file);
        return await instance.post(INTERVIEW_SCHEDULE_VALIDATE_IMPORT + "?postId=" + postId, body);
    },
    async confirmImport(postId, file) {
        const body = new FormData();
        body.append('files[]', file);
        return await instance.post(INTERVIEW_SCHEDULE_CONFIRM_IMPORT + "?postId=" + postId, body);
    },
    async search(postId, status, interviewDate) {
        const params = [];
        if (postId) params.push('postId=' + postId);
        if (status) params.push('status=' + encodeURIComponent(status));
        if (interviewDate) params.push('interviewDate=' + encodeURIComponent(interviewDate));
        return await instance.get(INTERVIEW_SCHEDULE_SEARCH + (params.length ? '?' + params.join('&') : ''));
    },
    async getById(id) {
        return await instance.get(INTERVIEW_SCHEDULE_GET_BY_ID + "?id=" + id);
    },
    async release(id) {
        return await instance.post(INTERVIEW_SCHEDULE_RELEASE + "?id=" + id);
    },
    async unrelease(id) {
        return await instance.post(INTERVIEW_SCHEDULE_UNRELEASE + "?id=" + id);
    },
    async archive(id) {
        return await instance.post(INTERVIEW_SCHEDULE_ARCHIVE + "?id=" + id);
    },
    async update(model) {
        return await instance.post(INTERVIEW_SCHEDULE_UPDATE, model);
    },

    // Candidate-facing, authenticated (student auth-token) — never anonymous.
    async getForCandidate() {
        return await instance.get(INTERVIEW_SCHEDULE_GET_FOR_CANDIDATE);
    },

    // Phase C (Interview Call Letter) — admin-facing, Global-Admin-gated on the backend.
    async validateCallLetterRelease(postId) {
        return await instance.get(INTERVIEW_SCHEDULE_VALIDATE_CALL_LETTER_RELEASE + "?postId=" + postId);
    },
    async previewCallLetter(postId) {
        return await instance.get(INTERVIEW_SCHEDULE_PREVIEW_CALL_LETTER + "?postId=" + postId);
    },
    async releaseCallLetters(postId) {
        return await instance.post(INTERVIEW_SCHEDULE_RELEASE_CALL_LETTERS + "?postId=" + postId);
    },
    async unreleaseCallLetters(postId) {
        return await instance.post(INTERVIEW_SCHEDULE_UNRELEASE_CALL_LETTERS + "?postId=" + postId);
    },

    // Candidate-facing, authenticated (student auth-token) — never anonymous.
    async getCallLetterForCandidate() {
        return await instance.get(INTERVIEW_SCHEDULE_GET_CALL_LETTER_FOR_CANDIDATE);
    },
    async recordCallLetterDownload() {
        return await instance.post(INTERVIEW_SCHEDULE_RECORD_CALL_LETTER_DOWNLOAD);
    }
};

export default _InterviewScheduleService;
